import { Pipe, PipeTransform } from '@angular/core';
import { WorkDataSuggestionObject } from '@libs/types/src/services/object-type/work/work-data-suggestion.object';

@Pipe({
    name: 'suggestionDaysLeft',
})
export class SuggestionDaysLeftPipe implements PipeTransform {
    transform(item: { dateFrom?: string | null, workData?: WorkDataSuggestionObject | null }): number | null {
        return suggestionDaysLeft(item);
    }
}

export function suggestionDaysLeft(item: { dateFrom?: string | null, workData?: WorkDataSuggestionObject | null }): number | null {
    const daysToProcess = item?.workData?.complaintType?.daysToProcess;
    if (daysToProcess == null || !item.dateFrom) return null;

    const daysPassed = Math.floor((new Date().getTime() - new Date(item.dateFrom).getTime()) / (1000 * 3600 * 24));
    return daysToProcess - daysPassed;
}
